<template>
  <div class="webapp-layout-ai" :class="{ show: hasClass }" id="collapseAi">
    <button class="btn btn-dark btn-ai" @click="toggleClass">
      <img
        src="../../../../packages/pz-ui/img/ai-avator.png"
        width="40px"
        height="40px"
        class=""
      />
    </button>

    <div class="ai-inner">
      <!-- <Spinner
        displayType="fixed"
        v-if="isRequest"
        text="Thinking"
      /> -->
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div class="d-flex align-items-center">
          <img
            class="mr-2"
            src="../../../../packages/pz-ui/img/ai-icon.png"
            width="28px"
            height="28px"
          />
          <span class="text-light small">品小职 AI 助手</span>
        </div>
        <button class="btn btn-link text-light" @click="toggleClass">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="card h-100">
        <div class="card-body">
          <div class="ai-start" v-if="!aiHistoryRes && !started">
            <div class="text-center mb-4 mt-5">
              <img
                src="../../../../packages/pz-ui/img/ai-avator.png"
                width="64px"
                height="64px"
                class="mb-3"
              />
              <h5>同学你好，我是 AI 顾问 “品小职”～</h5>
            </div>
            <div class="mes_input">
              <input
                class="form-control"
                type="text"
                v-model="searchTxt"
                :placeholder="
                  isRequest ? '正在思考...' : '请用一句话说明您的问题'
                "
                :readonly="isRequest"
                @keyup.enter="doSearch"
              />

              <button
                class="btn btn-primary"
                type="button"
                :disabled="isRequest"
                @click="doSearch"
              >
                <svg
                  v-if="!isRequest"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.0002 7.82494L6.10016 12.7249C5.90016 12.9249 5.66683 13.0209 5.40016 13.0129C5.13349 13.0049 4.90016 12.9006 4.70016 12.6999C4.51683 12.4999 4.42083 12.2666 4.41216 11.9999C4.40349 11.7333 4.49949 11.4999 4.70016 11.2999L11.3002 4.69994C11.4002 4.59994 11.5085 4.52928 11.6252 4.48794C11.7418 4.44661 11.8668 4.42561 12.0002 4.42494C12.1335 4.42428 12.2585 4.44528 12.3752 4.48794C12.4918 4.53061 12.6002 4.60128 12.7002 4.69994L19.3002 11.2999C19.4835 11.4833 19.5752 11.7126 19.5752 11.9879C19.5752 12.2633 19.4835 12.5006 19.3002 12.6999C19.1002 12.8999 18.8628 12.9999 18.5882 12.9999C18.3135 12.9999 18.0758 12.8999 17.8752 12.6999L13.0002 7.82494V18.9999C13.0002 19.2833 12.9042 19.5209 12.7122 19.7129C12.5202 19.9049 12.2828 20.0006 12.0002 19.9999C11.7175 19.9993 11.4802 19.9033 11.2882 19.7119C11.0962 19.5206 11.0002 19.2833 11.0002 18.9999V7.82494Z"
                    fill="white"
                  />
                </svg>
                <svg
                  v-if="isRequest"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="24" height="24" fill="#17B3A3" />
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="white"
                    stroke-width="4"
                    stroke-linecap="round"
                    fill="none"
                    stroke-dasharray="62.8"
                    stroke-dashoffset="47"
                  >
                    <animateTransform
                      attributeType="XML"
                      attributeName="transform"
                      type="rotate"
                      from="0 12 12"
                      to="360 12 12"
                      dur="1s"
                      repeatCount="indefinite"
                    />
                  </circle>
                </svg>
              </button>
            </div>
          </div>
          <div v-if="started" ref="scrollContainer">
            <div
              class="d-flex flex-column"
              v-for="(item, index) in aiHistoryRes"
              :key="`qa-${index}`"
              :id="`qa-${index}`"
            >
              <div class="question mb-5">{{ item.question }}</div>
              <div class="answer mb-5" v-if="item.answer">
                <!-- <div class="answer-loading"></div> -->
                <div class="h5">智能答案</div>
                <p class="small text-secondary">
                  内容由 AI 生成，不能完全保障真实
                </p>
                <p>
                  {{ item.answer }}
                </p>
                <!-- <p>
                  发行人为什么担心r下降啊 r下降他不是刚好可以以更低的成本发新的么
                  他不应该想让r下降吗 这样不是price升高他能募集到的钱更
                </p> -->

                <div
                  class="video mt-4"
                  v-if="item.resultVideo && item.resultVideo.length"
                >
                  <p class="text-info mb-3">相关知识点：</p>
                  <div class="list-group">
                    <a
                      href="javascript:undefined"
                      class="list-group-item list-group-item-action py-2 px-3"
                      @click.prevent="openPlayer(video)"
                      v-for="video in item.resultVideo"
                      :key="`video-idx-${video.bulletId}`"
                    >
                      <div class="media">
                        <div class="d-flex mr-3 video-icon mt-1 _v2"></div>
                        <div class="media-body">
                          {{ video.bulletName }}
                          <small class="text-secondary d-block">
                            时长: {{ video.durationString }}
                          </small>
                        </div>
                      </div>
                    </a>
                    <!--  -->
                  </div>
                </div>
                <!-- <div class="related my-5" v-if="item.followup && item.followup.length">
                  <div class="h5">推荐问题</div>
                  <ul class="list-unstyled">
                    <li class="mb-2" :key="ii" v-for="(subQuestion, ii) in item.followup">
                      <a
                        href="javascript:undefined"
                        @click="doFollowup(subQuestion.content)"
                        class="btn btn-light"
                        >{{ subQuestion.content }}</a
                      >
                    </li>
                  </ul>
                </div> -->
              </div>
            </div>
            <div
              class="answer-loading"
              id="ai-answer-loading"
              v-if="isRequest"
            ></div>
          </div>
        </div>

        <div class="card-footer bg-white border-0">
          <div class="mes_input" v-if="started">
            <input
              class="form-control"
              type="text"
              :placeholder="
                isRequest ? '正在思考...' : '请用一句话说明您的问题'
              "
              :readonly="isRequest"
              v-model="searchTxt"
              @keyup.enter="doSearch"
            />

            <button
              class="btn btn-primary"
              type="button"
              :disabled="isRequest"
              @click="doSearch"
            >
              <svg
                v-if="!isRequest"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.0002 7.82494L6.10016 12.7249C5.90016 12.9249 5.66683 13.0209 5.40016 13.0129C5.13349 13.0049 4.90016 12.9006 4.70016 12.6999C4.51683 12.4999 4.42083 12.2666 4.41216 11.9999C4.40349 11.7333 4.49949 11.4999 4.70016 11.2999L11.3002 4.69994C11.4002 4.59994 11.5085 4.52928 11.6252 4.48794C11.7418 4.44661 11.8668 4.42561 12.0002 4.42494C12.1335 4.42428 12.2585 4.44528 12.3752 4.48794C12.4918 4.53061 12.6002 4.60128 12.7002 4.69994L19.3002 11.2999C19.4835 11.4833 19.5752 11.7126 19.5752 11.9879C19.5752 12.2633 19.4835 12.5006 19.3002 12.6999C19.1002 12.8999 18.8628 12.9999 18.5882 12.9999C18.3135 12.9999 18.0758 12.8999 17.8752 12.6999L13.0002 7.82494V18.9999C13.0002 19.2833 12.9042 19.5209 12.7122 19.7129C12.5202 19.9049 12.2828 20.0006 12.0002 19.9999C11.7175 19.9993 11.4802 19.9033 11.2882 19.7119C11.0962 19.5206 11.0002 19.2833 11.0002 18.9999V7.82494Z"
                  fill="white"
                />
              </svg>
              <svg
                v-if="isRequest"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="24" height="24" fill="#17B3A3" />
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="white"
                  stroke-width="4"
                  stroke-linecap="round"
                  fill="none"
                  stroke-dasharray="62.8"
                  stroke-dashoffset="47"
                >
                  <animateTransform
                    attributeType="XML"
                    attributeName="transform"
                    type="rotate"
                    from="0 12 12"
                    to="360 12 12"
                    dur="1s"
                    repeatCount="indefinite"
                  />
                </circle>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import { debounce } from 'lodash';
import Swal from 'sweetalert2';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      hasClass: false,
      started: false,
      searchTxt: '',
    };
  },

  computed: {
    isButtonEnabled() {
      return this.searchTxt.trim() !== '';
    },

    ...mapState('AI', {
      isRequest: 'isRequest',
    }),

    ...mapGetters({
      userInfo: 'userInfo',
      immLoading: 'immLoading',
      aopLoading: 'aopLoading',
    }),

    ...mapGetters('AI', {
      aiHistoryRes: 'aiHistoryRes',
    }),
  },

  watch: {
    aiHistoryRes(newValue) {
      if (newValue !== null) {
        this.started = true;
      }
    },
  },

  created() {
    if (!this.userInfo.unLogin) {
      this.$store.dispatch('AI/getAiHistory');
      this.scrollToBottom();
    }
  },

  methods: {
    toggleClass() {
      this.hasClass = !this.hasClass;
    },

    async doFollowup(txt) {
      await this.$store.dispatch('AI/doAiSearch', { search: txt });
    },

    async doSearch() {
      if (this.searchTxt && this.searchTxt.trim() != '') {
        const promise = this.$store.dispatch('AI/doAiSearch', {
          search: this.searchTxt,
        });
        this.searchTxt = '';
        this.scrollToBottom();
        await promise;
        this.scrollToBottom();
      }
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const id = this.isRequest
          ? 'ai-answer-loading'
          : `qa-${this.aiHistoryRes.length - 1}`;
        const qa = document.getElementById(id);
        console.log(qa);
        if (qa) {
          qa.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest',
          });
        }
      });
    },

    openPlayer(video) {
      this.$emit('open-player', video);
    },
  },
};
</script>

<style scoped>
.answer-loading {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'%3e%3ccircle fill='%23dcdcdc' stroke='%23dcdcdc' stroke-width='15' r='15' cx='40' cy='100'%3e%3canimate attributeName='opacity' calcMode='spline' dur='2' values='1;0;1;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.4'%3e%3c/animate%3e%3c/circle%3e%3ccircle fill='%23dcdcdc' stroke='%23dcdcdc' stroke-width='15' r='15' cx='100' cy='100'%3e%3canimate attributeName='opacity' calcMode='spline' dur='2' values='1;0;1;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.2'%3e%3c/animate%3e%3c/circle%3e%3ccircle fill='%23dcdcdc' stroke='%23dcdcdc' stroke-width='15' r='15' cx='160' cy='100'%3e%3canimate attributeName='opacity' calcMode='spline' dur='2' values='1;0;1;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='0'%3e%3c/animate%3e%3c/circle%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 30px;
  height: 30px;
}

.ai-start {
  margin-top: 25%;
  margin-bottom: 3rem;
}

.mes_input {
  position: relative;
}

.mes_input .form-control {
  border-radius: 1rem;
  border: 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 1rem 4rem 1rem 1rem !important;
  height: 56px;
}

.mes_input .btn {
  position: absolute;
  right: 5px;
  top: 4px;
  border-radius: 50rem;
  width: 48px;
  height: 48px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.question {
  display: inline-block;
  background-color: #d4fffa;
  max-width: 80%;
  padding: 1rem;
  border-radius: 0.5rem;
  align-self: flex-end;
}

.question::after,
.question::before {
  display: block;
  clear: both;
  content: '';
}

.webapp-layout-ai {
  background-color: #00595f;
  flex: 0 0 0rem;
  position: relative;
  transition: 0.2s ease-out;
}

.webapp-layout-ai .ai-inner {
  display: none;
  opacity: 0;
  height: 100%;
  transition: 0.2s;
}

.webapp-layout-ai.show {
  flex: 0 0 25rem;
}

.webapp-layout-ai.show .ai-inner {
  opacity: 1;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
}

.btn-ai {
  position: fixed;
  z-index: 1000;
  bottom: 10%;
  right: 1rem;
  width: 40px;
  height: 40px;
  padding: 0;
  align-items: center;
  justify-content: center;
  color: #fff;
  border: 0;
  border-radius: 50rem;
  transition: 0.2s ease-out;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
}

.webapp-layout-ai.show .btn-ai {
  right: calc(25rem + 10px);
}

.webapp-layout-ai .card {
  overflow: hidden;
}

.webapp-layout-ai .card-body {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
</style>
